import React, {useEffect, useState} from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './index.scss'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import {persistor, store} from './redux/store/store'
import setupInterceptors from './custom/axios/config/Interceptors'
import {I18nextProvider} from 'react-i18next'
import i18n from './translation/i18n'
import setupNormal from './custom/axios/normal/config/Interceptors'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import {ConfigProvider} from 'antd'
import vi_VN from 'antd/es/locale/vi_VN';
import en_US from 'antd/es/locale/en_US';
import de_DE from 'antd/es/locale/de_DE';
import {ApolloProvider} from '@apollo/client'
import {client} from './custom/graphql'
import DocumentMeta from 'react-document-meta'
import 'dayjs/locale/vi'
import 'dayjs/locale/en-au'
import 'dayjs/locale/de'
import dayjs from 'dayjs'
import {getLanguage} from './custom/axios'
import {GoogleOAuthProvider} from "@react-oauth/google";

const clientId = "514273365473-gqke0uiupmjmis5bh31ll1acgrmfe333.apps.googleusercontent.com"

dayjs.locale(getLanguage())

const root = ReactDOM.createRoot(document.getElementById('root'))

const meta = {
    title: 'Dogoo Office - Phần mềm quản lý doanh nghiệp vừa và nhỏ',
    description:
        'Giải pháp số toàn diện giúp bạn quản lý công việc, dự án, thu chi ngân sách và nhân sự. Dễ dàng đo lường siệu suất, kiểm soát nhân sự. Dùng thử miễn phí ngay',
    canonical: 'https://dogoo.vn/',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'react,meta,document,html,tags'
        }
    }
}

function getAntdLocale(lang) {

    switch (lang) {
        case "en":
            return en_US;
        case "de":
            return de_DE;
        default:
            return vi_VN;
    }
}

const RootApp = () => {
    const [language, setLanguage] = useState(getLanguage());

    useEffect(() => {
        const handleLanguageChange = () => {
            const newLang = getLanguage();
            setLanguage(newLang);
            dayjs.locale(newLang);
        };

        window.addEventListener("languageChange", handleLanguageChange);

        return () => {
            window.removeEventListener("languageChange", handleLanguageChange);
        };
    }, []);

    return (
        <I18nextProvider i18n={i18n}>
            <DocumentMeta {...meta}>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <ConfigProvider locale={getAntdLocale(language)}>
                            <GoogleOAuthProvider clientId={clientId}>
                                <ApolloProvider client={client}>
                                    <App/>
                                </ApolloProvider>
                            </GoogleOAuthProvider>
                        </ConfigProvider>
                    </PersistGate>
                </Provider>
            </DocumentMeta>
        </I18nextProvider>
    );
};

root.render(<RootApp/>);
setupInterceptors(store)
setupNormal(store)
serviceWorkerRegistration.unregister()
reportWebVitals()
